import styled from '@emotion/styled';
import { Modal, Button } from '@mantine/core';
import { useEffect, useState } from 'react';
import { HARDCODED_VALUES } from '../hardcoded-values';

const WarningContent = styled.div`
    font-family: "Work Sans", sans-serif;
    padding: 1rem;
    
    h2 {
        font-size: 1.5rem;
        font-weight: 600;
        color: #ff6b6b;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }
    
    p {
        line-height: 1.7;
        margin-bottom: 1rem;
        color: #e8e8e8;
    }
    
    .discord-link {
        color: #7289da;
        text-decoration: none;
        font-weight: 500;
        
        &:hover {
            text-decoration: underline;
        }
    }
`;

export function MacIOSWarning() {
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        // Check if user has already seen the warning
        const hasSeenWarning = localStorage.getItem('mac-ios-warning-seen');
        
        if (!hasSeenWarning) {
            // Enhanced Mac/iOS detection
            const userAgent = navigator.userAgent.toLowerCase();
            const isMac = userAgent.includes('macintosh') || userAgent.includes('mac os x');
            const isIOS = /ipad|iphone|ipod/.test(userAgent) || (isMac && 'ontouchend' in document);
            
            if (isMac || isIOS) {
                // Show warning after a brief delay so the page can load
                setTimeout(() => setOpened(true), 1000);
            }
        }
    }, []);

    const handleClose = () => {
        setOpened(false);
        // Mark as seen so it doesn't show again
        localStorage.setItem('mac-ios-warning-seen', 'true');
    };

    return (
        <Modal
            opened={opened}
            onClose={handleClose}
            title={null}
            centered
            size="md"
            styles={{
                modal: {
                    backgroundColor: '#303038',
                    border: '2px solid #ff6b6b',
                },
                header: {
                    backgroundColor: 'transparent',
                },
                close: {
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    },
                },
            }}
        >
            <WarningContent>
                <h2>
                    ⚠️ Mac/iOS Compatibility Warning
                </h2>
                <p>
                    We've detected you're using a Mac or iPhone. Unfortunately, this service may not work properly on your device due to browser limitations.
                </p>
                <p>
                    We're actively working on fixing these compatibility issues. In the meantime, we recommend:
                </p>
                <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem', lineHeight: '1.7' }}>
                    <li>• Using a Windows PC or Android device</li>
                    <li>• Trying a different browser (Chrome or Firefox recommended)</li>
                </ul>
                <p>
                    For updates and support, please join our{' '}
                    <a 
                        href={HARDCODED_VALUES.discord.inviteLink}
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="discord-link"
                    >
                        Discord community
                    </a>
                    !
                </p>
                <Button 
                    fullWidth 
                    variant="light" 
                    onClick={handleClose}
                    style={{ marginTop: '1rem' }}
                >
                    I Understand
                </Button>
            </WarningContent>
        </Modal>
    );
}

